import { useSelector } from 'react-redux';

import { selectMeteorologyAgroWBCultureTriggerRequest } from 'redux/reducers/meteorologyAgroWBCultureReducer';
import useGroup from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useGroup';
import useLocation from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useLocation';
import useCulture from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useCulture';
import useEmergency from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useEmergency';
import usePeriod from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/usePeriod';
import useSoil from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useSoil';
import useChartVariable from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useChartVariable';
import useGraphData from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useGraphData';
import useParams from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useParams';
import useClearSelection from 'hooks/Meteorology/Agro/WaterBalanceCulture/DetailedView/useClearSelection';

export default function useDetailedViewMobile() {
  const group = useGroup();
  const location = useLocation();
  const culture = useCulture();
  const emergency = useEmergency();
  const period = usePeriod();
  const soil = useSoil();
  const chartVariable = useChartVariable();
  const params = useParams();
  const {
    graphData, runDate, isFetching: graphDataLoading, queryError, onRetry,
  } = useGraphData();
  const clearControlPanel = useClearSelection();
  const triggerRequest = useSelector(selectMeteorologyAgroWBCultureTriggerRequest);

  return {
    group,
    location,
    culture,
    emergency,
    period,
    soil,
    chartVariable,
    params,
    graphData,
    runDate,
    graphDataLoading,
    queryError,
    onRetry,
    clearControlPanel,
    triggerRequest,
  };
}
